import { render, staticRenderFns } from "./UsuariosActivos.vue?vue&type=template&id=7e4a68fa&"
import script from "./UsuariosActivos.vue?vue&type=script&lang=js&"
export * from "./UsuariosActivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports